import { Text } from '@billy/design-system'
import type { ReactElement } from 'react'

interface DocumentTypeSettingsCharacterCountProps {
  length: number
  limit: number
}

export const DocumentTypeSettingsCharacterCount = ({
  length,
  limit,
}: DocumentTypeSettingsCharacterCountProps): ReactElement => (
  <Text colorVariant="secondary" variant="bodySM">{`${length}/${limit}`}</Text>
)
